import { Link } from 'react-router-dom';
import productFooter from './img/block-product-footer.png';
// import { useContext } from 'react';
// import { CategoriesContext } from '../../../App';
// import { selectImage } from '../../../util/misc';
// import DownloadCatalogBtn from './elements/download-catalog-btn';
// import { Category } from '../../../types/catalog';

// function OniHome() {
//     const { categories } = useContext(CategoriesContext);
//     // все 2 уровня
//     const displayedCategories: Category[] = categories
//         .map((c) => c.children)
//         .flat(1)
//         .filter((c) => c) as Category[];
//     return (
//         <div className="block-products-module col-sm-12 col-md-8">
//             {displayedCategories.map((cat) => {
//                 const imageUrl = selectImage(cat.imageVariants, 400, 200, cat.imageUrl);
//                 return (
//                     <div key={cat.slug} className="col-sm-6 product-folder">
//                         <Link to={cat.url}>
//                             <img src={imageUrl} alt="" className="img-responsive products-folder-img" />
//                             <div className="products-link text-center">
//                                 {cat.name}
//                                 <img src={productFooter} alt="" className="img-responsive" />
//                             </div>
//                         </Link>
//                     </div>
//                 );
//             })}
//         </div>
//     );
// }

function OniHomeDumb() {
    return (
        <div className="block-products-module col-sm-12 col-md-8" style={{ marginTop: '15px' }}>
            <div className="col-sm-6 product-folder">
                <Link to="/avtomatizatsiya_zdaniy_i_protsessov/oborudovanie_avtomatizatsii_protsessov/programmiruemye_logicheskie_kontrollery/">
                    <img
                        alt=""
                        src="/local/templates/onisystem/img/img_ws/Oni_controllers_840_2.png"
                        className="img-responsive products-folder-img"
                    />
                    <div className="products-link text-center">
                        Программируемые контроллеры
                        <img src={productFooter} alt="" className="img-responsive" />
                    </div>
                </Link>
            </div>

            <div className="col-sm-6 product-folder">
                <a href="/smart-home/">
                    <img alt="" src="/images/smart_home.png" className="img-responsive products-folder-img" />
                    <div className="products-link text-center">
                        Оборудование SMART HOME ONI iTEQ
                        <img src={productFooter} alt="" className="img-responsive" />
                    </div>
                </a>
            </div>

            <div className="col-sm-6 product-folder">
                <Link to="/avtomatizatsiya_zdaniy_i_protsessov/oborudovanie_avtomatizatsii_protsessov/cheloveko_mashinnyy_interfeys/emkostnye_paneli_operatora_etc/">
                    <img
                        alt=""
                        src="/local/templates/onisystem/img/img_ws/Oni_operator_panels_840.png"
                        className="img-responsive products-folder-img"
                    />
                    <div className="products-link text-center">
                        Панели оператора
                        <img src={productFooter} alt="" className="img-responsive" />
                    </div>
                </Link>
            </div>

            <div className="col-sm-6 product-folder">
                <Link to="/avtomatizatsiya_zdaniy_i_protsessov/chastotno_reguliruemyy_privod/preobrazovateli_chastoty/">
                    <img
                        alt=""
                        src="/images/Oni_Frequency_Converters_840x356.png"
                        className="img-responsive products-folder-img"
                    />
                    <div className="products-link text-center">
                        Преобразователи частоты
                        <img src={productFooter} alt="" className="img-responsive" />
                    </div>
                </Link>
            </div>

            <div className="col-md-6 product-folder">
                <Link to="/avtomatizatsiya_zdaniy_i_protsessov/chastotno_reguliruemyy_privod/ustroystva_plavnogo_puska/">
                    <img
                        alt=""
                        src="/images/Oni_Soft_Starters_840x356.png"
                        className="img-responsive products-folder-img"
                    />
                    <div className="products-link text-center">
                        Устройства плавного пуска
                        <img src={productFooter} alt="" className="img-responsive" />
                    </div>
                </Link>
            </div>

            <div className="col-sm-6 product-folder">
                <Link to="/avtomatizatsiya_zdaniy_i_protsessov/kontrolno_izmeritelnye_pribory_i_avtomatika/datchiki_dlya_sistem_promyshlennoy_avtomatizatsii/">
                    <img
                        alt=""
                        src="/images/pressure_temperature.png"
                        className="img-responsive products-folder-img"
                    />
                    <div className="products-link text-center">
                        Датчики давления и температуры
                        <img src={productFooter} alt="" className="img-responsive" />
                    </div>
                </Link>
            </div>

            <div className="col-sm-6 product-folder">
                <Link to="/avtomatizatsiya_zdaniy_i_protsessov/oborudovanie_avtomatizatsii_protsessov/bloki_pitaniya_promyshlennye/">
                    <img
                        alt=""
                        src="/local/templates/onisystem/img/img_ws/Power_supplies.png"
                        className="img-responsive products-folder-img"
                    />
                    <div className="products-link text-center">
                        Блоки питания
                        <img src={productFooter} alt="" className="img-responsive" />
                    </div>
                </Link>
            </div>

            <div className="col-sm-6 product-folder">
                <Link to="/avtomatizatsiya_zdaniy_i_protsessov/kontrolno_izmeritelnye_pribory_i_avtomatika/ispolnitelnye_mekhanizmy/privody_vozdushnykh_zaslonok/">
                    <img alt="" src="/images/zaslonki.png" className="img-responsive products-folder-img" />
                    <div className="products-link text-center">
                        Приводы заслонок
                        <img src={productFooter} alt="" className="img-responsive" />
                    </div>
                </Link>
            </div>

            <div className="col-md-6 product-folder">
                <Link to="/avtomatizatsiya_zdaniy_i_protsessov/avtomatika_releynaya/">
                    <img alt="" src="/images/photo9.png" className="img-responsive products-folder-img" />
                    <div className="products-link text-center">
                        Релейная автоматика
                        <img src={productFooter} alt="" className="img-responsive" />
                    </div>
                </Link>
            </div>

            <div className="col-sm-6 product-folder">
                <Link to="/avtomatizatsiya_zdaniy_i_protsessov/elektrodvigateli/elektrodvigateli_asinkhronnye/">
                    <img alt="" src="/images/photo1.jpg" className="img-responsive products-folder-img" />
                    <div className="products-link text-center">
                        Электродвигатели
                        <img src={productFooter} alt="" className="img-responsive" />
                    </div>
                </Link>
            </div>
        </div>
    );
}

export default OniHomeDumb;
